import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, HeartPulse } from "lucide-react";
import { HOSPITAL, SERVICES } from "../lib/hospitalData";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="section-navy mt-16 md:mt-24">
      <div className="container-x py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/logo.png" alt="Logo" className="h-12 w-auto object-contain bg-white rounded-md p-1" />
            <div className="leading-tight">
              <div className="font-display text-lg font-bold">Godhra Heart Hospital</div>
              <div className="text-[10.5px] tracking-[0.2em] uppercase text-white/70">Super Specialty Care</div>
            </div>
          </div>
          <p className="text-white/75 text-sm leading-relaxed">
            {HOSPITAL.tagline}. Compassionate, affordable cardiac and super-specialty healthcare for Godhra and the Panchmahal region.
          </p>
          <div className="flex items-center gap-2 mt-5 text-white/80 text-sm">
            <HeartPulse className="w-4 h-4 text-brand-crimson animate-heart-pulse" />
            <span>75-Bed Multi-Specialty Hospital</span>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-white">Quick Links</h4>
          <ul className="space-y-2.5 text-sm">
            {[["About","/about"],["Services","/services"],["Our Doctors","/doctors"],["Facilities","/facilities"],["Contact","/contact"]].map(([l,h]) => (
              <li key={h}><Link to={h} className="text-white/75 hover:text-white transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-white">Specialties</h4>
          <ul className="space-y-2.5 text-sm">
            {SERVICES.slice(0,6).map((s) => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`} className="text-white/75 hover:text-white transition-colors">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-white">Reach Us</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2.5">
              <MapPin className="w-4 h-4 mt-0.5 text-brand-crimson shrink-0" />
              <span>{HOSPITAL.address.line1}<br/>{HOSPITAL.address.city}, {HOSPITAL.address.district}<br/>{HOSPITAL.address.state} – {HOSPITAL.address.pincode}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="w-4 h-4 text-brand-crimson" />
              <a href={`tel:${HOSPITAL.phoneRaw}`} className="hover:text-white">{HOSPITAL.phone}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="w-4 h-4 text-brand-crimson" />
              <a href={`mailto:${HOSPITAL.email}`} className="hover:text-white">{HOSPITAL.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-4 md:py-5 flex flex-col md:flex-row items-center justify-between gap-2 md:gap-3 text-[11px] md:text-xs text-white/60 text-center md:text-left">
          <span>© {new Date().getFullYear()} {HOSPITAL.name}. All rights reserved.</span>
          <span>www.{HOSPITAL.domain}</span>
        </div>
      </div>
    </footer>
  );
}
